<template>
  <div class="row roomy align-stretch">
    <div
      v-if="isNewAccount"
      class="column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0"
    >
      <article
        id="accounts"
        class="card"
        style="height: 100%"
      >
        <font-awesome-icon
          :icon="$v6.solid.faUser"
          :style="`color: var(--fa-dk-${theme});`"
          size="3x"
          fixed-width
          class="padding-2xs"
        />
        <div class="text-left size-sm">
          <h3 class="h4 margin-top-lg">Ahhh! That New Account Smell.</h3>
          <p>
            Along with this purchase, we also created
            <site-link :to="{ name: 'account' }">a Font Awesome Account</site-link>
            for you to make managing your subscription, features, and details over time easier.
          </p>
        </div>
      </article>
    </div>

    <div class="column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0">
      <article
        id="invoices"
        class="card"
        style="height: 100%"
      >
        <font-awesome-icon
          :icon="$v6.solid.faReceipt"
          size="3x"
          fixed-width
          class="padding-2xs"
          :style="`color: var(--fa-dk-$(theme));`"
        />
        <div class="text-left size-sm">
          <h3 class="h4 margin-top-lg">Invoices &amp; Receipts</h3>
          <p>
            You can find
            <site-link :to="{ name: 'account.billing' }">a print-friendly invoice of this purchase</site-link>
            in the Billing section of your Account. Add extra information (business address, VAT number, etc.) to the invoice by viewing it.
          </p>
        </div>
      </article>
    </div>

    <div class="column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0">
      <article
        id="questions"
        class="card"
        style="height: 100%"
      >
        <font-awesome-icon
          :icon="$v6.solid.faHeadset"
          :style="`color: var(--fa-dk-${theme});`"
          size="3x"
          fixed-width
          class="padding-2xs"
        />
        <div class="text-left size-sm">
          <h3 class="h4 margin-top-lg">Have a Question or Need Help?</h3>
          <p>
            Is something about this order confusing or mistaken? We're here to help.
            <a
              href="mailto:hello@fontawesome.com?subject=I need help with a purchase that was made, Font Awesome!"
              @click="supportLinkClicked('commission_success_view, footer')"
              >Get in touch</a
            >
            and let us know the details.
          </p>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'SuccessFooter',

    mixins: [EventTrackingMixin],

    props: {
      theme: {
        type: String
      },

      isNewAccount: {
        type: Boolean
      }
    }
  }
</script>
